import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
    readonly #window = inject(DOCUMENT).defaultView as Window;
    readonly #online = signal(this.#window.navigator.onLine);
    readonly online = this.#online.asReadonly();
    readonly online$ = toObservable(this.online);

    constructor() {
        this.#window.addEventListener('online', () => this.#online.set(true));
        this.#window.addEventListener('offline', () => this.#online.set(false));
    }
}
